import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SupportedLanguage,
} from "./types";

// Import translation files
import enTranslations from "./locales/en.json";
import arTranslations from "./locales/ar.json";

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      [SupportedLanguage.EN]: {
        translation: enTranslations,
      },
      [SupportedLanguage.AR]: {
        translation: arTranslations,
      },
    },
    lng: localStorage.getItem(LANGUAGE_STORAGE_KEY) || undefined, // Use stored language or auto-detect
    fallbackLng: DEFAULT_LANGUAGE,
    debug: process.env.NODE_ENV === "development",
    load: "languageOnly", // Ignore region codes (e.g., en-US becomes en)
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of detection methods
      order: ["localStorage"],
      // Cache user language
      caches: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
  });

export default i18n;
